export const ScribeTrainings = {
    FR_1_chirac: {
        name: 'FR_1_chirac',
        url: 'https://ava-scribe-trainings.s3.us-west-2.amazonaws.com/FR_1_chirac.mp3',
        language: 'fr-FR',
    },
    FR_1_degaulle: {
        name: 'FR_1_degaulle',
        url: 'https://ava-scribe-trainings.s3.us-west-2.amazonaws.com/FR_1_degaulle.mp3',
        language: 'fr-FR',
    },
    FR_1_pomme_20min: {
        name: 'FR_1_pomme_20min',
        url: 'https://ava-scribe-trainings.s3.us-west-2.amazonaws.com/FR_1_pomme_20min.mp3',
        language: 'fr-FR',
    },
    FR_2_braqueur_fr_1: {
        name: 'FR_2_braqueur_fr_1',
        url: 'https://ava-scribe-trainings.s3.us-west-2.amazonaws.com/FR_2_braqueur-fr-1.mp3',
        language: 'fr-FR',
    },
    FR_2_braqueur_fr_2: {
        name: 'FR_2_braqueur_fr_2',
        url: 'https://ava-scribe-trainings.s3.us-west-2.amazonaws.com/FR_2_braqueur-fr-2.mp3',
        language: 'fr-FR',
    },
    FR_2_braqueur_fr_3: {
        name: 'FR_2_braqueur_fr_3',
        url: 'https://ava-scribe-trainings.s3.us-west-2.amazonaws.com/FR_2_braqueur-fr-3.mp3',
        language: 'fr-FR',
    },
    FR_2_braqueur_mi_1: {
        name: 'FR_2_braqueur_mi_1',
        url: 'https://ava-scribe-trainings.s3.us-west-2.amazonaws.com/FR_2_braqueur-mi-1.mp3',
        language: 'fr-FR',
    },
    FR_2_braqueur_mi_2: {
        name: 'FR_2_braqueur_mi_2',
        url: 'https://ava-scribe-trainings.s3.us-west-2.amazonaws.com/FR_2_braqueur-mi-2.mp3',
        language: 'fr-FR',
    },
    FR_2_braqueur_mi_3: {
        name: 'FR_2_braqueur_mi_3',
        url: 'https://ava-scribe-trainings.s3.us-west-2.amazonaws.com/FR_2_braqueur-mi-3.mp3',
        language: 'fr-FR',
    },
    FR_2_braqueur_mi_4: {
        name: 'FR_2_braqueur_mi_4',
        url: 'https://ava-scribe-trainings.s3.us-west-2.amazonaws.com/FR_2_braqueur-mi-4.mp3',
        language: 'fr-FR',
    },
    FR_2_braqueur_mi_5: {
        name: 'FR_2_braqueur_mi_5',
        url: 'https://ava-scribe-trainings.s3.us-west-2.amazonaws.com/FR_2_braqueur-mi-5.mp3',
        language: 'fr-FR',
    },
    FR_2_braqueur_ti_1: {
        name: 'FR_2_braqueur_ti_1',
        url: 'https://ava-scribe-trainings.s3.us-west-2.amazonaws.com/FR_2_braqueur-ti-1.mp3',
        language: 'fr-FR',
    },
    FR_2_braqueur_ti_2: {
        name: 'FR_2_braqueur_ti_2',
        url: 'https://ava-scribe-trainings.s3.us-west-2.amazonaws.com/FR_2_braqueur-ti-2.mp3',
        language: 'fr-FR',
    },
    FR_2_braqueur_ti_3: {
        name: 'FR_2_braqueur_ti_3',
        url: 'https://ava-scribe-trainings.s3.us-west-2.amazonaws.com/FR_2_braqueur-ti-3.mp3',
        language: 'fr-FR',
    },
    FR_2_thibava: {
        name: 'FR_2_thibava',
        url: 'https://ava-scribe-trainings.s3.us-west-2.amazonaws.com/FR_2_thibava.mp3',
        language: 'fr-FR',
    },
    FR_4_darwin0: {
        name: 'FR_4_darwin0',
        url: 'https://ava-scribe-trainings.s3.us-west-2.amazonaws.com/FR_4_darwin0.mp3',
        language: 'fr-FR',
    },
    FR_4_vampire1: {
        name: 'FR_4_vampire1',
        url: 'https://ava-scribe-trainings.s3.us-west-2.amazonaws.com/FR_4_vampire1.mp3',
        language: 'fr-FR',
    },
    FR_4_vampire2: {
        name: 'FR_4_vampire2',
        url: 'https://ava-scribe-trainings.s3.us-west-2.amazonaws.com/FR_4_vampire2.mp3',
        language: 'fr-FR',
    },
    FR_4_vampire3: {
        name: 'FR_4_vampire3',
        url: 'https://ava-scribe-trainings.s3.us-west-2.amazonaws.com/FR_4_vampire3.mp3',
        language: 'fr-FR',
    },
    FR_4_vampire4: {
        name: 'FR_4_vampire4',
        url: 'https://ava-scribe-trainings.s3.us-west-2.amazonaws.com/FR_4_vampire4.mp3',
        language: 'fr-FR',
    },
    FR_4_vampire5: {
        name: 'FR_4_vampire5',
        url: 'https://ava-scribe-trainings.s3.us-west-2.amazonaws.com/FR_4_vampire5.mp3',
        language: 'fr-FR',
    },
    FR_4_vampire6: {
        name: 'FR_4_vampire6',
        url: 'https://ava-scribe-trainings.s3.us-west-2.amazonaws.com/FR_4_vampire6.mp3',
        language: 'fr-FR',
    },
    FR_5_quidam2: {
        name: 'FR_5_quidam2',
        url: 'https://ava-scribe-trainings.s3.us-west-2.amazonaws.com/FR_5_quidam2.mp3',
        language: 'fr-FR',
    },
    FR_6_quidam1: {
        name: 'FR_6_quidam1',
        url: 'https://ava-scribe-trainings.s3.us-west-2.amazonaws.com/FR_6_quidam1.mp3',
        language: 'fr-FR',
    },
    US_1Speaker: {
        name: 'US_1Speaker',
        url: 'https://ava-scribe-trainings.s3.us-west-2.amazonaws.com/US_1Speaker.mp3',
        language: 'en-US',
    },
    US_2_plastic: {
        name: 'US_2_plastic',
        url: 'https://ava-scribe-trainings.s3.us-west-2.amazonaws.com/US_2_plastic.mp3',
        language: 'en-US',
    },
    US_2speakers: {
        name: 'US_2speakers',
        url: 'https://ava-scribe-trainings.s3.us-west-2.amazonaws.com/US_2speakers.mp3',
        language: 'en-US',
    },
    US_3_computers: {
        name: 'US_3_computers',
        url: 'https://ava-scribe-trainings.s3.us-west-2.amazonaws.com/US_3_computers.mp3',
        language: 'en-US',
    },
    US_4Speakers: {
        name: 'US_4Speakers',
        url: 'https://ava-scribe-trainings.s3.us-west-2.amazonaws.com/US_4Speakers.mp3',
        language: 'en-US',
    },
    US_4_jobinterview: {
        name: 'US_4_jobinterview',
        url: 'https://ava-scribe-trainings.s3.us-west-2.amazonaws.com/US_4_jobinterview.mp3',
        language: 'en-US',
    },
};
const initialState = {
    rooms: [],
    scribeTrainingRequested: false,
};
export default function scribeDashboard(state = initialState, action) {
    switch (action.type) {
        case 'SCRIBE_DASHBOARD_WS_URL': {
            return Object.assign(Object.assign({}, state), { scribeUrl: action.scribeUrl });
        }
        case 'SCRIBE_DASHBOARD_REQUEST_TRAINING': {
            return Object.assign(Object.assign({}, state), { scribeTrainingRequested: true, scribeTrainingSelected: action.selected });
        }
        case 'SCRIBE_DASHBOARD_STREAM_READY': {
            console.log('setting scribe training audio stream');
            return Object.assign(Object.assign({}, state), { scribeTrainingSourceNode: action.sourceNode, scribeTrainingAudioStreamAC: action.ac });
        }
        case 'SCRIBE_DASHBOARD_ROOMS_UPDATE': {
            switch (action.subtype) {
                case 'add-room':
                    if (action.room && action.room.id) {
                        return Object.assign(Object.assign({}, state), { rooms: [
                                // $FlowFixMe
                                ...state.rooms.filter((r) => r.id !== action.room.id),
                                action.room,
                            ] });
                    }
                    break;
                case 'room-status-update':
                    if (action.room) {
                        return Object.assign(Object.assign({}, state), { rooms: [
                                // $FlowFixMe
                                ...state.rooms.filter((r) => r.id !== action.room.id),
                                action.room,
                            ] });
                    }
                    break;
                case 'remove-room':
                    return Object.assign(Object.assign({}, state), { 
                        // $FlowFixMe
                        rooms: state.rooms.filter((r) => r.id !== action.room.id) });
                default:
                    break;
            }
            return state;
        }
        default:
            // eslint-disable-next-line no-unused-expressions
            action;
            return state;
    }
}
